import httpWrapper from '../HttpWrapper'
import { GetCompaniesReq } from './models/getCompanies/GetCompaniesReq'
import { GetCompaniesRes } from './models/getCompanies/GetCompaniesRes'
import { SearchCompaniesRes } from './models/search/SearchCompaniesRes'
import {
    MergeCompanyCsReq,
    MergeCompanyCsRes,
    SearchCompanyCsParams,
    SearchCompanyCsRes,
    FindMatchingCompanyCsReq,
    FindMatchingCompanyCsRes,
    ImportCurrentEmployeesForCompaniesReq,
    ImportCurrentEmployeesForCompaniesRes,
    GetTalentFlowByCompaniesReq,
    GetTalentFlowRes,
} from './models/companyCs/CompanyCsDtos'
import {
    ResolveCompanyNamesReq,
    ResolveCompanyNamesRes,
} from './models/resolveCompanyNames/ResolveCompanyNamesDtos'

class CompanyApi {
    private static instance: CompanyApi

    public constructor() {
        if (CompanyApi.instance) {
            return CompanyApi.instance
        }

        CompanyApi.instance = this
    }

    public async searchCompanies(
        searchTerm: string,
    ): Promise<SearchCompaniesRes> {
        const queryParams = new URLSearchParams({
            q: searchTerm,
        })

        return await httpWrapper.get<SearchCompaniesRes>(
            '/company/search',
            queryParams,
        )
    }

    public async getNumberOfCompanyNodes(): Promise<number> {
        return await httpWrapper.get<number>('/company/count')
    }

    public async getCompanies(data: GetCompaniesReq): Promise<GetCompaniesRes> {
        return await httpWrapper.post('/company/get-companies', data)
    }

    public async searchCompanyCs(
        params: SearchCompanyCsParams = {},
    ): Promise<SearchCompanyCsRes> {
        const queryParams = new URLSearchParams()
        if (params.q && params.q.trim()) {
            queryParams.set('q', params.q.trim())
        }
        if (params.pageNumber) {
            queryParams.set('pageNumber', String(params.pageNumber))
        }
        if (params.perPage) {
            queryParams.set('perPage', String(params.perPage))
        }
        if (
            params.companyEntityFilter &&
            params.companyEntityFilter !== 'all'
        ) {
            queryParams.set('companyEntityFilter', params.companyEntityFilter)
        }
        if (params.searchMode) {
            queryParams.set('searchMode', params.searchMode)
        }

        return await httpWrapper.get<SearchCompanyCsRes>(
            '/company-cs/search',
            queryParams,
        )
    }

    public async mergeCompanyCs(
        req: MergeCompanyCsReq,
    ): Promise<MergeCompanyCsRes> {
        return await httpWrapper.post<MergeCompanyCsReq, MergeCompanyCsRes>(
            '/company-cs/merge',
            req,
        )
    }

    public async findMatchingCompanyCs(
        req: FindMatchingCompanyCsReq,
    ): Promise<FindMatchingCompanyCsRes> {
        return await httpWrapper.post<
            FindMatchingCompanyCsReq,
            FindMatchingCompanyCsRes
        >('/company-cs/matching', req)
    }

    public async importCurrentEmployeesForCompanies(
        req: ImportCurrentEmployeesForCompaniesReq,
    ): Promise<ImportCurrentEmployeesForCompaniesRes> {
        return await httpWrapper.post<
            ImportCurrentEmployeesForCompaniesReq,
            ImportCurrentEmployeesForCompaniesRes
        >('/company-cs/import-current-employees', req)
    }

    public async getTalentFlowCompanies(
        req: GetTalentFlowByCompaniesReq,
    ): Promise<GetTalentFlowRes> {
        return await httpWrapper.post<
            GetTalentFlowByCompaniesReq,
            GetTalentFlowRes
        >('/company-cs/talent-flow/companies', req)
    }

    public async resolveCompanyNames(
        req: ResolveCompanyNamesReq,
    ): Promise<ResolveCompanyNamesRes> {
        return await httpWrapper.post<
            ResolveCompanyNamesReq,
            ResolveCompanyNamesRes
        >('/company/resolve-names-admin', req)
    }
}

const companyApi = new CompanyApi()
export default companyApi
